import { errorCellRenderer } from "../components/flowTable";
import { FlowTableColumn } from "../components/flowTable/types";

export const cdnColumns: FlowTableColumn[] = [
  { data: "as_name", header: "Nome", type: "text", width: 240 },
  { data: "as_num", header: "ASN", type: "text", width: 140 },
  { data: "tipo", header: "Tipo", type: "text", width: 140 },
  { data: "bloco", header: "Bloco", type: "text", width: 240 },
];

export const cdnMassColumns: FlowTableColumn[] = cdnColumns.map((column) => ({
  ...column,
  renderer: errorCellRenderer,
}));
